import { PATHS } from '../paths';
import { DeepLinkGroup, Order, OrderId } from '@interfaces/order';
import { AxiosInstance, RawAxiosRequestHeaders } from 'axios';
import { ReceiptState } from '@interfaces/receipts';

export default (httpClient: AxiosInstance, endpoint = PATHS.BASE_URL) => ({
  getOrderDetail(orderId: OrderId) {
    return httpClient.get<Order>(
      `${endpoint}${PATHS.ORDER.orderDetail(orderId)}`
    );
  },
  depositConfirmed(invoiceId: OrderId) {
    const apiPath = PATHS.ORDER.depositConfirmed(invoiceId);
    return httpClient.post(`${endpoint}${apiPath}`);
  },
  uploadReceipts(
    invoiceId: OrderId,
    receipt: FormData,
    source: 'web' | 'link'
  ) {
    const apiPath = PATHS.ORDER.uploadReceipts(invoiceId);
    return httpClient.post(`${endpoint}${apiPath}`, receipt, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Source: source,
      } as RawAxiosRequestHeaders,
    });
  },
  uploadCancellation(orderId: OrderId, formData: FormData) {
    return httpClient.post(
      `${endpoint}${PATHS.ORDER.uploadCancellation(orderId)}`,
      formData,
    );
  },
  getReceiptsState(orderId: OrderId) {
    return httpClient.get<ReceiptState>(
      `${endpoint}${PATHS.ORDER.getReceiptsState}`,
      {
        params: {
          order_id: orderId,
        },
      }
    );
  },
  retryRequisites(orderId: OrderId) {
    return httpClient.post(
      `${endpoint}${PATHS.ORDER.retryRequisites(orderId)}`
    );
  },
  getDeepLinks(orderId: OrderId) {
    return httpClient.get<DeepLinkGroup[]>(
      `${endpoint}${PATHS.ORDER.getDeepLinks(orderId)}`
    );
  },
  downloadReceiptUrl(receiptId: string) {
    return `${endpoint}${PATHS.ORDER.downloadReceipt(receiptId)}`;
  },
  downloadReceipt(receiptId: string) {
    return httpClient.get<Blob>(
      `${endpoint}${PATHS.ORDER.downloadReceipt(receiptId)}`,
      { responseType: 'blob' }
    );
  },
});
